<template>
  <div class="box-forgot-password clearfix" v-show="forgotPasswordDisp || forgotPasswordVerifyDisp">
    <forgot-password-request v-show="forgotPasswordDisp"
                             :forgotPasswordDisp="forgotPasswordDisp"
                             :pcDisp="pcDisp"
                             :loadingDisp="loadingDisp"
                             :goLogin="goLogin"
                             :postForgotPassword="postForgotPassword"
                             :response="response"
                             :setForgotPasswordResponse="setForgotPasswordResponse"
                             :inputUsername="inputUsername"
                             :labels="labels" />

    <forgot-password-verify  v-show="forgotPasswordVerifyDisp"
                             :pcDisp="pcDisp"
                             :goLogin="goLogin"
                             :postForgotPasswordVerify="postForgotPasswordVerify"
                             :response="response"
                             :setResponse="setForgotPasswordResponse"
                             :inputUsername="inputUsername"
                             :labels="labels" />
  </div>
</template>

<script>
import forgotPasswordRequest from 'components/login/forgotPasswordRequest'
import forgotPasswordVerify from 'components/login/forgotPasswordVerify'

export default {
  name: 'forgot-password',
  props: [
    'pcDisp',
    'goLogin',
    'postForgotPassword',
    'response',
    'setForgotPasswordResponse',
    'inputUsername',
    'loadingDisp',
    'forgotPasswordDisp',
    'forgotPasswordVerifyDisp',
    'postForgotPasswordVerify',
    'labels' ],
  components: {
    forgotPasswordRequest,
    forgotPasswordVerify
  }
}
</script>



// WEBPACK FOOTER //
// forgotPassword.vue?083f75f0